import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import parse from 'react-html-parser';
import { Border } from '../../RecogntionAdmin/styles';
import { ImageUrl } from '../../../utils/constants';
import { CalendarHeader,StyledModal } from '../../common/CommonModal/style';
import { AdminCloseIcon } from '../../../utils/icons';
import { InitiativesContainer } from './styles';
import { CommonButtonPopup } from '../../ReportsV2/styles';

const UserInitiativePopup = ({
  showPopup,
  initiativeData,
  history,
  user,
  onClose,
  showConfirmVisitModal,
  onCancel,
  title,
  icon
}) => {
  if (!initiativeData) return null;

  const handleConfirmClick = () => {
    if (initiativeData.type === 'HRA') {
      history.push('/wellness-assessment');
    } else if (initiativeData.type === 'BIOMETRIC') {
      history.push(
        `/profile/biometric/${user.uid}/multi-step/physician-form`
      );
    } else {
      showConfirmVisitModal();
    }
  };

  return (
    <StyledModal
      show={showPopup}
      width={initiativeData.about ? '400px' : '400px'}
      height="480"
    >
      {/* <div className="modal-container">
        <div
          onClick={onClose}
          style={{ margin: '14px 0px 0px -14px', cursor: 'pointer' }}
        >
          {closeIcon()}
        </div>

        <div
          style={{
            color: '#005C87',
            marginTop: '0px',
            textDecoration: 'none',
            fontSize: '18px',
          }}
        >
          Recommended To Complete
        </div>
      </div>

      <Border
        style={{
          background: 'rgba(0, 92, 135, 0.10)',
          margin: '20px 0px 0px 0px',
        }}
      /> */}

      <div>
        <CalendarHeader>
          <div className="left-content">
            <div className="icon">{icon && icon}</div>
            <div>{title || 'Recommended to complete'}</div>
          </div>
          <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <Border/>
      </div>


      <Modal.Body>
        <InitiativesContainer background={initiativeData?.color}>
          <div className="icon-name">
            <div className="icon">
              <img
                className='initiative-image'
                src={`${ImageUrl}/${initiativeData?.initiative_white_icon}`}
                alt={initiativeData?.name || "initiative"}
                onError={(e) => { e.currentTarget.src = `${ImageUrl}/default-initiative.png`; }}
              />
            </div>
            <div className="name">{initiativeData.name}</div>
          </div>

          <Border/>

          {initiativeData.about && (
            <>
              <div className="ini-name">About the initiative</div>
              <div className="about">
                {parse(initiativeData.about)}
              </div>
            </>
          )}

          <CommonButtonPopup
            onClick={handleConfirmClick}
            width="100%"
          >
            {/* {initiativeData.type === 'HRA' ||
            initiativeData.type === 'BIOMETRIC'
              ? 'Next'
              : 'Confirm Details'} */}
              Next
          </CommonButtonPopup>
        </InitiativesContainer>
      </Modal.Body>
    </StyledModal>
  );
};

UserInitiativePopup.propTypes = {
  history: PropTypes.object.isRequired,
  user:PropTypes.object,
  initiativeData:PropTypes.object,
  showPopup:PropTypes.bool,
  onClose:PropTypes.func,
  showConfirmVisitModal:PropTypes.func,
  onCancel:PropTypes.func,
  title:PropTypes.string,
  icon:PropTypes.string
}

export default UserInitiativePopup;
